var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Icon',{attrs:{"classes":'entity-folder-tree-view__collapse-icon',"icon":"play","icon-pack":"fas","size":"xs","rotation":_vm.rotation}})
}
var staticRenderFns = []

export { render, staticRenderFns }